module.exports = __webpack_public_path__ + "img/bar2_1.f726be66.png";